export const TRANSFERENCIA_STATUS = {
  0: { key: 'Criado', label: 'Criado', color: 'default' },
  1: { key: 'Separado', label: 'Separado', color: 'warning' },
  2: { key: 'Concluido', label: 'Concluído', color: 'success' },
  3: { key: 'Cancelado', label: 'Cancelado', color: 'error' },
  Criado: { key: 'Criado', label: 'Criado', color: 'default' },
  Separado: { key: 'Separado', label: 'Separado', color: 'warning' },
  Concluido: { key: 'Concluido', label: 'Concluído', color: 'success' },
  Cancelado: { key: 'Cancelado', label: 'Cancelado', color: 'error' },
};

export function statusTransferencia(status) {
  return TRANSFERENCIA_STATUS[status] || { key: String(status), label: String(status), color: 'default' };
}

const PERM_MAP = {
  consultar: 'transferenciaConsultar',
  criar: 'transferenciaCriar',
  editar: 'transferenciaEditar',
  separar: 'transferenciaSeparar',
  concluir: 'transferenciaConcluir',
  cancelar: 'transferenciaCancelar',
};

export function podeTransferencia(permissions, action) {
  if (permissions == null) return true;
  if (permissions.acessoGerencial) return true;
  const key = PERM_MAP[action];
  return key ? Boolean(permissions[key]) : false;
}

export function formatNumeroRomaneio(numero) {
  return numero || '—';
}
